import React from "react";
import styled, {css} from "styled-components";
import Utility from "../../utility";
import {dashboardMenuImages, pathConstants} from "../../constants";
import ProductsComponent from "../products";
import CategoriesComponent from "../category";
import UserListComponent from "../users";
import AddCategoriesComponent from "../addCategory";
import Home from "../home";
import AddProductComponent from "../addProduct/addProduct";
import {Catalogue} from "../catalogue";
import AddBannerComponent from "../addBanner";
import BannersComponent from "../banners";
import SettingsComponent from "../settings";
import SubscriptionPlans from "../plans";
import SubscriptionList from "../subscriptionRequest";
import {ParentCategories} from "../categoryParent";
import AddCategoryParentComponent from "../addCategoryParent";
import ReferralList from "../referrals";

const SideMenuContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
    width: 222px;
    padding-top: 15px;
    background-color: #832729;
`;

const MenuTitle = styled.span`
    margin: 0 0 0 20px;
    font-size: 16px;
    text-align: left;
    color: #ffffff;
`;


const MenuImage = styled.img`
    width: 18px;
    height: 18px;
`;

const MenuContainer = styled.span`
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 8px 20px;
    margin: 5px 0;
    cursor: pointer;
    ${(props) =>
            props.isSelected
                    ? css`
                        font-weight: 400;
                        background-color: #A76F24;
                    `
                    : css`
                        font-weight: 300;
                    `}
`;
const AppLogo = styled.span`
    font-size: 16px;
    margin-top: 50px;
    margin-bottom: 50px;
    display: block;
    color: white;
    font-weight: bold;
`;

const SideMenuComponent = (props) => {
    return (
        <SideMenuContainer>
            <AppLogo>My Gold Work Admin</AppLogo>
            <MenuContainer
                isSelected={Utility.isMenuActive("/home")}
                onClick={() => props.onMenuClick(pathConstants.DASHBOARD_MENU.HOME)}
            >
                <MenuImage
                    alt="home"
                    src={dashboardMenuImages.HOSPITALS[Utility.isMenuActive("/home")]}
                />
                <MenuTitle>Home</MenuTitle>
            </MenuContainer>
            <MenuContainer
                isSelected={Utility.isMenuActive("/categories")}
                onClick={() =>
                    props.onMenuClick(pathConstants.DASHBOARD_MENU.CATEGORIES)
                }
            >
                <MenuImage
                    alt="categories"
                    src={
                        dashboardMenuImages.CATEGORIES[Utility.isMenuActive("/categories")]
                    }
                />
                <MenuTitle>Categories</MenuTitle>
            </MenuContainer>
            <MenuContainer
                isSelected={Utility.isMenuActive("/sub-categories")}
                onClick={() =>
                    props.onMenuClick(pathConstants.DASHBOARD_MENU.SUB_CATEGORIES)
                }
            >
                <MenuImage
                    alt="sub-categories"
                    src={
                        dashboardMenuImages.CATEGORIES[Utility.isMenuActive("/sub-categories")]
                    }
                />
                <MenuTitle>Sub Categories</MenuTitle>
            </MenuContainer>
            <MenuContainer
                isSelected={Utility.isMenuActive("/items")}
                onClick={() => props.onMenuClick(pathConstants.DASHBOARD_MENU.PRODUCTS)}
            >
                <MenuImage
                    alt="products"
                    src={dashboardMenuImages.PRODUCTS[Utility.isMenuActive("/products")]}
                />
                <MenuTitle>Products</MenuTitle>
            </MenuContainer>
            <MenuContainer
                isSelected={Utility.isMenuActive("/catalogue")}
                onClick={() => props.onMenuClick(pathConstants.DASHBOARD_MENU.CATALOGUE)}
            >
                <MenuImage
                    alt="catalogue"
                    src={dashboardMenuImages.CATALOGUE[Utility.isMenuActive("/catalogue")]}
                />
                <MenuTitle>Catalogue</MenuTitle>
            </MenuContainer>

            {/*<MenuContainer*/}
            {/*    isSelected={Utility.isMenuActive("/banners")}*/}
            {/*    onClick={() =>*/}
            {/*        props.onMenuClick(pathConstants.DASHBOARD_MENU.BANNERS)*/}
            {/*    }*/}
            {/*>*/}
            {/*    <MenuImage*/}
            {/*        alt="categories"*/}
            {/*        src={*/}
            {/*            dashboardMenuImages.CATEGORIES[Utility.isMenuActive("/banners")]*/}
            {/*        }*/}
            {/*    />*/}
            {/*    <MenuTitle>Banners</MenuTitle>*/}
            {/*</MenuContainer>*/}
            <MenuContainer
                isSelected={Utility.isMenuActive("/plans")}
                onClick={() => props.onMenuClick(pathConstants.DASHBOARD_MENU.PLANS)}
            >
                <MenuImage
                    alt="plans"
                    src={dashboardMenuImages.PLANS[Utility.isMenuActive("/plans")]}
                />
                <MenuTitle>Plans</MenuTitle>
            </MenuContainer>
            <MenuContainer
                isSelected={Utility.isMenuActive("/referrals")}
                onClick={() => props.onMenuClick(pathConstants.DASHBOARD_MENU.REFERRALS)}
            >
                <MenuImage
                    alt="plans"
                    src={dashboardMenuImages.REFERRALS[Utility.isMenuActive("/referrals")]}
                />
                <MenuTitle>Referrals</MenuTitle>
            </MenuContainer>
            <MenuContainer
                isSelected={Utility.isMenuActive("/subscriptions")}
                onClick={() => props.onMenuClick(pathConstants.DASHBOARD_MENU.SUBSCRIPTIONS)}
            >
                <MenuImage
                    alt="subscriptions"
                    src={dashboardMenuImages.CATALOGUE[Utility.isMenuActive("/subscriptions")]}
                />
                <MenuTitle>Subscriptions</MenuTitle>
            </MenuContainer>
            <MenuContainer
                isSelected={Utility.isMenuActive("/users")}
                onClick={() => props.onMenuClick(pathConstants.DASHBOARD_MENU.USERS)}
            >
                <MenuImage
                    alt="users"
                    src={dashboardMenuImages.SETTINGS[Utility.isMenuActive("/users")]}
                />
                <MenuTitle>Users</MenuTitle>
            </MenuContainer>
            <MenuContainer
                isSelected={Utility.isMenuActive("/settings")}
                onClick={() => props.onMenuClick(pathConstants.DASHBOARD_MENU.SETTINGS)}
            >
                <MenuImage
                    alt="settings"
                    src={dashboardMenuImages.SETTINGS[Utility.isMenuActive("/settings")]}
                />
                <MenuTitle>Settings</MenuTitle>
            </MenuContainer>
        </SideMenuContainer>
    );
};

const Container = styled.div`
    height: 100%;
    width: 100%;
    font-size: 32px;
    overflow-y: auto;
    display: flex;
    flex-direction: row;
    text-align: center;
    min-height: 88vh;
    padding: 40px;
    color: #3a3a3a;
`;

//Replace Under Development with component once developed-
const HomeComponent = () => {
    return (
        <Container>
            {Utility.isMenuActive("/home") && <Home/>}
            {Utility.isMenuActive("/categories") &&
                (Utility.isMenuActive("/add") ? (
                    <AddCategoryParentComponent/>
                ) : (
                    <ParentCategories/>
                ))}
            {Utility.isMenuActive("/sub-categories") &&
                (Utility.isMenuActive("/add") ? (
                    <AddCategoriesComponent/>
                ) : (
                    <CategoriesComponent/>
                ))}
            {Utility.isMenuActive("/banners") &&
                (Utility.isMenuActive("/add") ? (
                    <AddBannerComponent/>
                ) : (
                    <BannersComponent/>
                ))}

            {Utility.isMenuActive("/items") &&
                (Utility.isMenuActive("/add") ? (
                    <AddProductComponent/>
                ) : (
                    <ProductsComponent/>
                ))}

            {Utility.isMenuActive("/catalogue") && <Catalogue/>}
            {Utility.isMenuActive("/settings") && <SettingsComponent>Under Development</SettingsComponent>}
            {Utility.isMenuActive("/users") && <UserListComponent/>}
            {Utility.isMenuActive("/plans") && <SubscriptionPlans/>}
            {Utility.isMenuActive("/referrals") && <ReferralList/>}
            {Utility.isMenuActive("/subscriptions") && <SubscriptionList/>}
        </Container>
    );
};

const DashboardContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    overflow-y: hidden;
`;

const HomeContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
`;

const dashboardComponent = (props) => {
    return (
        <DashboardContainer>
            <SideMenuComponent {...props} />
            <HomeContainer>
                <HomeComponent {...props} />
            </HomeContainer>
        </DashboardContainer>
    );
};
export default dashboardComponent;
